import { mapGetters } from "vuex";

import { apolloClient } from '@/apollo'
import gql from "graphql-tag";

import ExcelJS from "exceljs";
import * as fs from "file-saver";

import { ASYNC_SEARCH } from "@riophae/vue-treeselect";

import Archive from "./pages/private/Components/Archive";
import FilesUpload from "./pages/private/Components/FilesUpload";

let today = new Date()

let today_start = new Date()
today_start.setHours(0, 0, 0, 0)
let today_end = new Date()
today_end.setHours(23, 59, 50, 0)

let yesterday_start = new Date()
yesterday_start.setDate(yesterday_start.getDate() - 1)
yesterday_start.setHours(0, 0, 0, 0);
let yesterday_end = new Date()
yesterday_end.setDate(yesterday_end.getDate() - 1)
yesterday_end.setHours(23, 59, 50, 0)

let thisYear = today.getFullYear();
let lastYear = thisYear - 1
let nextYear = thisYear + 1

export const uimixin = {
    components: { FilesUpload, Archive },
    props: ["config", "selection"],
    watch: {
        async limit() {
            if (this.limit == 15) {
                this.btable_height = 350;
            }
            if (this.limit == 25) {
                this.btable_height = 800;
            }
            if (this.limit == 50) {
                this.btable_height = 1600;
            }
            if (this.limit > 50) {
                this.btable_height = 3600;
            }
            await this.load()
        },
        async currentpage() {
            await this.load((this.currentpage - 1) * this.limit);
        },
        async showfilter() {
            if (!this.showfilter) {
                this.btable_height = 350;
            } else {
                this.btable_height = 800;
            }
        },
        selection: {
            immediate: true,
            async handler(newVal, oldVal) {
                if (newVal) {
                    console.log("mixin watch:selection", newVal);
                    try {
                        await this.loadDDL();
                    } catch (error) {

                    }
                    if (newVal.length > 0) {
                        if (newVal[0].id) {
                            this.idselected = newVal[0].id;
                            try {
                                await this.load();
                            } catch (error) {
                            }
                        }
                    }

                }
            },
        },
        mifields: {
            immediate: true,
            deep: true,
            async handler(newVal, oldVal) {
                if (newVal) {
                    if (this.item) {
                        if (this.item.tags) {
                            let tags = JSON.parse(this.item.tags)
                            if (newVal.length > 0) {
                                for (var k = 0; k < newVal.length; k++) {
                                    tags[newVal[k].key] = newVal[k].value;
                                    if (newVal[k].key == 'mi_P') {
                                        if (this.value) {
                                            this.value.yourref = newVal[k].value;
                                        }
                                    }
                                }
                            }
                            this.item.tags = JSON.stringify(tags)
                        }
                    }
                }
            }
        }
    },
    computed: {
        ...mapGetters(["window", "user"]),
        message1() {
            return this.message
        },
        excelitems() {
            return this[this.options.bvtid + "_items"];
        },
    },
    data() {
        return {
            content: [],
            tools: [
                {
                    type: "button",
                    size: "sm",
                    variant: "outline-white",
                    squared: "squared",
                    icon: "fa fa-refresh text-primary",
                    position: "toolbar",
                    action: "refresh",
                    label: "Reload",
                },
                {
                    type: "button",
                    size: "sm",
                    variant: "outline-white",
                    squared: "squared",
                    icon: "fa fa-filter text-primary",
                    position: "toolbar",
                    action: "filter",
                    label: "Filter",
                    component: {
                        name: "",
                    },
                },
                {
                    type: "button",
                    size: "sm",
                    variant: "outline-white",
                    squared: "squared",
                    icon: "fa fa-plus text-primary",
                    position: "toolbar",
                    action: "add",
                    label: "Add",
                    single: true,
                    multiple: false,
                    component: {
                        name: "",
                    },
                },
                // {
                //     type: "button",
                //     size: "sm",
                //     variant: "outline-white",
                //     squared: "squared",
                //     icon: "fa fa-plus text-primary",
                //     position: "toolbar",
                //     action: "new",
                //     label: "New",
                //     single: true,
                //     multiple: false,
                //     component: {
                //         name: "",
                //     },
                // },

                {
                    type: "button",
                    size: "sm",
                    variant: "outline-white",
                    squared: "squared",
                    icon: "fa fa-share-alt text-primary",
                    position: "toolbar",
                    action: "copy",
                    label: "Copy",
                    component: {
                        name: "",
                    },
                },
                {
                    type: "button",
                    size: "sm",
                    variant: "outline-white",
                    squared: "squared",
                    icon: "fa fa-cloud-upload text-primary",
                    position: "toolbar",
                    action: "import",
                    label: "Import",
                    component: {
                        name: "FilesUpload",
                        config: []
                    },
                },
                {
                    type: "button",
                    size: "sm",
                    variant: "outline-white",
                    squared: "squared",
                    icon: "fa fa-pencil text-primary",
                    position: "toolbar",
                    action: "edit",
                    label: "Edit",
                    component: {
                        name: "",
                    },
                },
                // {
                //     type: "button",
                //     size: "sm",
                //     variant: "outline-white",
                //     squared: "squared",
                //     icon: "fa fa-trash text-danger",
                //     position: "toolbar",
                //     action: "delete",
                //     label: "Delete",
                //     component: {
                //         name: "",
                //     },
                // },

                {
                    type: "button",
                    size: "sm",
                    variant: "outline-white",
                    squared: "squared",
                    icon: "fa fa-history text-danger",
                    action: "archive",
                    position: "toolbar",
                    label: "Archive",
                    component: {
                        name: "Archive",
                        config: []
                    },
                },
                {
                    type: "button",
                    size: "sm",
                    variant: "outline-white",
                    squared: "squared",
                    icon: "fa fa-file-excel-o text-primary",
                    position: "toolbar",
                    action: "export",
                    title: "Grid to Excel",
                    label: "Grid",
                },
            ],
            tables: [

            ],
            showfilter: false,
            autoquery: true,

            btable_busy: false,
            btable_height: 350,
            btable_selected: [],
            btable_items: [],
            btable_find: "",

            ctable_busy: false,
            ctable_height: 350,
            ctable_selected: [],
            ctable_items: [],
            ctable_find: "",

            component: null,
            cconfig: null,
            message: "",
            dateformat: "DD/MM/YY HH:MM:ss",  // MOMENT FORMAT
            idselected: null,
            textsize: "",
            eventtitle: "",
            clienttitle: "",
            locale_data: {
                direction: 'ltr',
                format: 'dd/mm/yy',
                applyLabel: 'OK',
                cancelLabel: 'Cancel',
                daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                firstDay: 1,
            },
            locale_ranges: {
                'Today': [today_start, today_end],
                // 'Yesterday': [yesterday_start, yesterday_end],
                'This month': [new Date(today.getFullYear(), today.getMonth(), 1), new Date(today.getFullYear(), today.getMonth() + 1, 0)],
                'Last month': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
                'This quarter': [this.$moment().startOf('quarter').toDate(), this.$moment().endOf('quarter').toDate()],
                // 'Next quarter': [this.$moment().add(1, 'quarter').startOf('quarter').toDate(), this.$moment().add(1, 'quarter').endOf('quarter').toDate()],
                'Last quarter': [this.$moment().subtract(1, 'quarter').startOf('quarter').toDate(), this.$moment().subtract(1, 'quarter').endOf('quarter').toDate()],
                'This year': [new Date(thisYear, 0, 1), new Date(thisYear, 11, 31)],
                'Last year': [new Date(lastYear, 0, 1), new Date(lastYear, 11, 31)],
                'Next year': [new Date(nextYear, 0, 1), new Date(nextYear, 11, 31)],
            },
            finance_ranges: {
                'This fiscal year': [new Date(thisYear, 3, 1), new Date(thisYear + 1, 2, 31)],
                'Last fiscal year': [new Date(lastYear, 3, 1), new Date(thisYear, 2, 31)],
            },
            export_limit: 50000,
            limit: 15,
            currentpage: 1,
            rows: 0,
            options_pagesizes: [
                { id: 15, label: "15" },
                { id: 25, label: "25" },
                { id: 50, label: "50" },
                { id: 100, label: "100" },
                { id: 500, label: "500" },
                { id: 5000, label: "All" },
            ],
            fileUpload: null,
            selected: [],
            mifields: [],
            requirement: {},
        }
    },
    methods: {
        async CMS() {
            this.content = []
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query container($name: String) {
                            container(name: $name) {
                        id
                        type
                        elements {
                            id
                            name
                            type
                            data
                        }
                    }
                }
                `,
                    variables: { name: this.$options.name },
                });
                this.content = response.data.container
            } catch (error) {
                console.log(error);
            }
        },
        // BTABLE HELPERS
        resizableColumns() {
            // RE-SIZE COLUMNS
            var thElm;
            var startOffset;

            Array.prototype.forEach.call(
                document.querySelectorAll("table th"),
                function (th) {
                    th.style.position = "relative";

                    var grip = document.createElement("div");
                    grip.innerHTML = "&nbsp;";
                    grip.style.top = 0;
                    grip.style.right = 0;
                    grip.style.bottom = 0;
                    grip.style.width = "5px";
                    grip.style.position = "absolute";
                    grip.style.cursor = "col-resize";
                    grip.addEventListener("mousedown", function (e) {
                        thElm = th;
                        startOffset = th.offsetWidth - e.pageX;
                    });

                    th.appendChild(grip);
                }
            );

            document.addEventListener("mousemove", function (e) {
                if (thElm) {
                    thElm.style.width = startOffset + e.pageX + "px";
                }
            });

            document.addEventListener("mouseup", function () {
                thElm = undefined;
            });
        },
        headselected(bvtbl) {
            if (this[bvtbl + '_selected'].length == 0) {
                return "fa fa-square-o";
            } else if (this[bvtbl + '_selected'].length == this[bvtbl + '_items'].length) {
                return "fa fa-check-square-o";
            } else {
                return "fa fa-minus-square-o";
            }
        },
        headselectedClick(bvtbl) {
            let tbl = this.$refs[bvtbl]
            if (this[bvtbl + '_items'].length > 0) {
                if (this[bvtbl + '_selected'].length == 0) {
                    tbl.selectAllRows();
                } else {
                    tbl.clearSelected();
                }
            }
        },
        tableItems(e, bvtbl, fields) {

            e.forEach(function (v) {
                delete v.__typename;
            });

            this[bvtbl + '_items'] = e;

            if (fields) {
                for (let i = 0; i < fields.length; ++i) {
                    let field = fields[i]
                    if (field.totalled) {
                        field.total = 0
                        if (!field.type) { field.type = "float" }
                        for (let j = 0; j < e.length; ++j) {
                            let row = e[j]
                            let value = 0
                            if (field.type == "int") {
                                value = parseInt(row[field.key])
                            } else {
                                value = parseFloat(row[field.key])
                            }
                            if (value >= 0) {
                                field.total += value;
                            } else {
                                field.total -= Math.abs(value);
                            }

                        }
                        if (field.type == "float") {
                            field.total = Math.round(field.total * 100) / 100;
                            field.total = this.$options.filters.currency(field.total, "")
                        }
                    }
                }
            }

        },
        rowSelected(e, bvtbl) {
            this[bvtbl + '_selected'] = e;
        },
        rowIcon(r) {
            let icon = this.options.icon
            if (r.running == 1 || r.runnow == 1) {
                icon += " text-warning"
            } else {
                icon += " text-primary"
            }
            return icon
        },
        rowBadgeCell(row, badge, options) {

            if (!row || !badge.key) return;
            var key = badge.key;
            if (!row.hasOwnProperty([badge.key])) {
                return;
            }
            var value = row[badge.key];
            if (badge.formatter) {
                value = badge.formatter(value, badge.key, row);
            }
            if (!value) {
                return;
            }
            var badge = options.badges.find((k) => k.key == key);
            if (badge) {
                switch (badge.type) {
                    case "pill":
                        var badgeClass = badge.class;
                        var badgeValue = value
                            .toString()
                            .replace(/^\w/, (c) => c.toUpperCase());
                        var badgeTitle = badgeValue
                        if (badge.title) {
                            if (row[badge.title]) {
                                badgeTitle = row[badge.title]
                            }
                        }
                        value =
                            "<span " +
                            "title='" +
                            badgeTitle +
                            "' " +
                            "class='badge badge-" +
                            badgeClass +
                            " badge-pill'" +
                            ">" +
                            badgeValue +
                            "</span>";
                        break;

                    case "badge":
                        var badgeClass = badge[value];
                        if (!badgeClass) {
                            badgeClass = badge["other"];
                        }
                        var badgeValue = value
                            .toString()
                            .replace(/^\w/, (c) => c.toUpperCase());
                        var badgeTitle = badgeValue
                        if (badge.title) {
                            if (row[badge.title]) {
                                badgeTitle = row[badge.title]
                            }
                        }
                        value =
                            "<span " +
                            "title='" +
                            badgeTitle +
                            "' " +
                            "class='badge badge-" +
                            badgeClass +
                            "'" +
                            ">" +
                            badgeValue +
                            "</span>";
                        break;

                    case "switch":
                        var badgeClass = badge[value];
                        var badgeValue = value
                            .toString()
                            .replace(/^\w/, (c) => c.toUpperCase());
                        var checked = "";
                        if (value == "enabled") {
                            checked = "checked";
                        }
                        value =
                            "<label class='switch-sm switch  switch-label switch-" +
                            badgeClass +
                            " form-check-label'>" +
                            "<input type='checkbox' true-value='" +
                            badgeValue +
                            "' false-value='no' class='switch-input form-check-input' value='" +
                            badgeValue +
                            "'" +
                            checked +
                            ">" +
                            "<span class='switch-slider'></span></label>";
                        break;

                    case "progressbar":
                        var badgeValue = value.toString(); //.substring(0,2)
                        if (!badgeClass) {
                            badge.class = "success";
                        }
                        if (parseFloat(badgeValue) > 100) {
                            badgeClass = "danger"
                        }
                        if (!badge.min) {
                            badge.min = 0;
                        }
                        if (!badge.max) {
                            badge.max = 100;
                        }
                        value =
                            "<div role='progressbar' class='progress-bar bg-" +
                            badge.class +
                            "'" +
                            "aria-valuemin='" +
                            badge.min +
                            "' " +
                            "aria-valuemax='" +
                            badge.max +
                            "' " +
                            "aria-valuenow='" +
                            badgeValue +
                            "' " +
                            "title='" +
                            badgeValue +
                            "%' " +
                            "style='width: " +
                            badgeValue +
                            "%;'>";
                        if (badge.label) {
                            value = value + badgeValue;
                        }
                        value = "</div><div class='progress'>" + value + "</div>";
                        break;
                }
            }
            return value;
        },
        rowActionCell(item, options) {
            var valid = [];
            for (let i = 0; i < options.actions.length; i++) {
                if (options.actions[i].rule) {
                    var rule = options.actions[i].rule;
                    var op = rule.toString().substring(0, 1);
                    var equalTo = true;
                    if (op == "!") {
                        equalTo = false;
                        rule = rule.substring(1);
                    }
                    if (item.hasOwnProperty(rule)) {
                        var state = item[rule];
                        if (
                            (state == true && equalTo == true) ||
                            (state == false && equalTo == false)
                        ) {
                            valid.push(options.actions[i]);
                        }
                    } else {
                        valid.push(options.actions[i]);
                    }
                } else {
                    valid.push(options.actions[i]);
                }
            }
            return valid;
        },
        rowActionIcon(a, row) {
            let icon = a.icon

            if (row.running == 1 || row.runnow == 1) {
                icon += " text-warning"
            }
            return icon
        },
        async rowClick(a, row, bvtbl) {
            this.$root.$emit("bv::hide::popover");
            console.log("rowClick, you have clicked: ", a, row.index);
            let tbl = this.$refs[bvtbl]
            if (tbl) { tbl.clearSelected(); }

            // SCROLL INTO VIEW
            if (row.index || row.index == 0) {
                console.log("rowScroll: ", row.index);
                tbl.selectRow(row.index)
                const tbody = tbl.$el.querySelector("tbody");
                const tr = tbody.querySelectorAll("tr")[row.index];
                tr.scrollIntoView();
            }
            this[bvtbl + '_selected'] = [this[bvtbl + '_items'][row.index]];
            if (this[bvtbl + '_items'][row.index].id) {
                this.idselected = this[bvtbl + '_items'][row.index].id
            }

            for (let i = 0; i < this.options.actions.length; i++) {
                if (this.options.actions[i].key == a) {
                    if (this.options.actions[i].hasOwnProperty("modal")) {
                        console.log(this.options.modal);
                        return;
                    }
                    if (this.options.actions[i].hasOwnProperty("component")) {
                        this.options.component = this.options.actions[i].component;
                        this.cconfig = { action: a, ...this.config }
                        this.cconfig.eventcode = this.eventcode
                        // ONLY ALLOW ONE EXPANSION
                        for (let k = 0; k < this.btable_items.length; k++) {
                            this.$set(this.btable_items[k], "_showDetails", false);
                        }
                        row.toggleDetails();
                        return;
                    }
                    if (this.options.actions[i].hasOwnProperty("overlay")) {
                        if (this.options.actions[i].overlay.message) {
                            let message = this.options.actions[i].overlay.message;
                            for (let prop in row.item) {
                                if (Object.prototype.hasOwnProperty.call(row.item, prop)) {
                                    message = message
                                        .split("%" + prop + "%")
                                        .join(row.item[prop]);
                                }
                            }
                            this.options.overlay.message = message;
                        }
                        if (this.options.actions[i].overlay.buttons) {
                            this.options.overlay.buttons =
                                this.options.actions[i].overlay.buttons;
                        }
                        this.options.overlay_show = !this.options.overlay_show;
                        return;
                    }
                }
            }

            await this._toolClick(a, row)
        },
        async table_excel(data) {
            try {
                const response = await apolloClient.query({
                    query: gql`
                  query setup_report_excel($data: String, $options: String) {
                    setup_report_excel(data: $data, options: $options)
                  }
                `,
                    variables: {
                        data: JSON.stringify(data),
                        options: JSON.stringify({}),
                    },
                });


                let workbook = new ExcelJS.Workbook();
                workbook.model = JSON.parse(response.data.setup_report_excel);
                workbook.created = new Date();
                workbook.modified = new Date();
                let buffer = await workbook.xlsx.writeBuffer();
                fs.saveAs(
                    new Blob([buffer], { type: "application/octet-stream" }),
                    "export" + this.$moment().format("_YYYYMMDDHHMMSS") + ".xlsx"
                );
            } catch (error) {
                console.log(error);
            }
        },



        // WILL NOT BE NEEDED WHEN USED LIKE ABOVE
        btable_iconselected() {
            if (this.btable_selected.length == 0) {
                return "fa fa-square-o";
            } else if (this.btable_selected.length == this.btable_items.length) {
                return "fa fa-check-square-o";
            } else {
                return "fa fa-minus-square-o";
            }
        },
        btable_iconselectedClick() {
            if (this.btable_items.length > 0) {
                if (this.btable_selected.length == 0) {
                    this.$refs.btable.selectAllRows();
                } else {
                    this.$refs.btable.clearSelected();
                }
            }
        },
        btable_rowSelected(items) {
            this.btable_selected = items;
        },

        btable_icon(row) {
            let icon = this.options.icon
            if (row.running == 1 || row.runnow == 1) {
                icon += " text-warning"
            } else {
                icon += " text-primary"
            }
            return icon
        },
        btable_rowBadgeCell(row, badge, options) {

            if (!row || !badge.key) return;
            var key = badge.key;
            if (!row.hasOwnProperty([badge.key])) {
                return;
            }
            var value = row[badge.key];
            if (badge.formatter) {
                value = badge.formatter(value, badge.key, row);
            }
            if (!value) {
                return;
            }
            var badge = options.badges.find((k) => k.key == key);
            if (badge) {
                switch (badge.type) {
                    case "pill":
                        var badgeClass = badge.class;
                        var badgeValue = value
                            .toString()
                            .replace(/^\w/, (c) => c.toUpperCase());
                        var badgeTitle = badgeValue
                        if (badge.title) {
                            if (row[badge.title]) {
                                badgeTitle = row[badge.title]
                            }
                        }
                        value =
                            "<span " +
                            "title='" +
                            badgeTitle +
                            "' " +
                            "class='badge badge-" +
                            badgeClass +
                            " badge-pill'" +
                            ">" +
                            badgeValue +
                            "</span>";
                        break;

                    case "badge":
                        var badgeClass = badge[value];
                        if (!badgeClass) {
                            badgeClass = badge["other"];
                        }
                        var badgeValue = value
                            .toString()
                            .replace(/^\w/, (c) => c.toUpperCase());
                        var badgeTitle = badgeValue
                        if (badge.title) {
                            if (row[badge.title]) {
                                badgeTitle = row[badge.title]
                            }
                        }
                        value =
                            "<span " +
                            "title='" +
                            badgeTitle +
                            "' " +
                            "class='badge badge-" +
                            badgeClass +
                            "'" +
                            ">" +
                            badgeValue +
                            "</span>";
                        break;

                    case "switch":
                        var badgeClass = badge[value];
                        var badgeValue = value
                            .toString()
                            .replace(/^\w/, (c) => c.toUpperCase());
                        var checked = "";
                        if (value == "enabled") {
                            checked = "checked";
                        }
                        value =
                            "<label class='switch-sm switch  switch-label switch-" +
                            badgeClass +
                            " form-check-label'>" +
                            "<input type='checkbox' true-value='" +
                            badgeValue +
                            "' false-value='no' class='switch-input form-check-input' value='" +
                            badgeValue +
                            "'" +
                            checked +
                            ">" +
                            "<span class='switch-slider'></span></label>";
                        break;

                    case "progressbar":
                        var badgeValue = value.toString(); //.substring(0,2)
                        var badgeClass = badge.class
                        if (!badgeClass) {
                            badge.class = "success";
                        }
                        if (parseFloat(badgeValue) > 100) {
                            badgeClass = "danger"
                        }
                        if (!badge.min) {
                            badge.min = 0;
                        }
                        if (!badge.max) {
                            badge.max = 100;
                        }
                        value =
                            "<div role='progressbar' class='progress-bar bg-" +
                            badgeClass +
                            "'" +
                            "aria-valuemin='" +
                            badge.min +
                            "' " +
                            "aria-valuemax='" +
                            badge.max +
                            "' " +
                            "aria-valuenow='" +
                            badgeValue +
                            "' " +
                            "title='" +
                            badgeValue +
                            "%' " +
                            "style='width: " +
                            badgeValue +
                            "%;'>";
                        if (badge.label) {
                            value = value + badgeValue;
                        }
                        value = "</div><div class='progress'>" + value + "</div>";
                        break;
                }
            }
            return value;
        },
        btable_rowActionCell(item, options) {
            var valid = [];
            for (let i = 0; i < options.actions.length; i++) {
                if (options.actions[i].rule) {
                    var rule = options.actions[i].rule;
                    var op = rule.toString().substring(0, 1);
                    var equalTo = true;
                    if (op == "!") {
                        equalTo = false;
                        rule = rule.substring(1);
                    }
                    if (item.hasOwnProperty(rule)) {
                        var state = item[rule];
                        if (
                            (state == true && equalTo == true) ||
                            (state == false && equalTo == false)
                        ) {
                            valid.push(options.actions[i]);
                        }
                    } else {
                        valid.push(options.actions[i]);
                    }
                } else {
                    valid.push(options.actions[i]);
                }
            }
            return valid;
        },
        btable_rowActionIcon(a, row) {
            let icon = a.icon

            if (row.running == 1 || row.runnow == 1) {
                icon += " text-warning"
            }
            return icon
        },
        async btable_rowClick(a, row) {
            this.$root.$emit("bv::hide::popover");
            console.log("rowClick, you have clicked: ", a, row.index);

            if (this.$refs.btable) { this.$refs.btable.clearSelected(); }

            // SCROLL INTO VIEW
            if (row.index || row.index == 0) {
                console.log("rowScroll: ", row.index);
                this.$refs.btable.selectRow(row.index)
                const tbody = this.$refs.btable.$el.querySelector("tbody");
                const tr = tbody.querySelectorAll("tr")[row.index];
                tr.scrollIntoView();
            }
            this.btable_selected = [this.btable_items[row.index]];
            if (this.btable_items[row.index].id) {
                this.idselected = this.btable_items[row.index].id
            }

            for (let i = 0; i < this.options.actions.length; i++) {
                if (this.options.actions[i].key == a) {
                    if (this.options.actions[i].hasOwnProperty("modal")) {
                        console.log(this.options.modal);
                        return;
                    }
                    if (this.options.actions[i].hasOwnProperty("component")) {
                        this.options.component = this.options.actions[i].component;
                        this.cconfig = { action: a, ...this.config }
                        this.cconfig.eventcode = this.eventcode
                        // ONLY ALLOW ONE EXPANSION
                        for (let k = 0; k < this.btable_items.length; k++) {
                            this.$set(this.btable_items[k], "_showDetails", false);
                        }
                        row.toggleDetails();
                        return;
                    }
                    if (this.options.actions[i].hasOwnProperty("overlay")) {
                        if (this.options.actions[i].overlay.message) {
                            let message = this.options.actions[i].overlay.message;
                            for (let prop in row.item) {
                                if (Object.prototype.hasOwnProperty.call(row.item, prop)) {
                                    message = message
                                        .split("%" + prop + "%")
                                        .join(row.item[prop]);
                                }
                            }
                            this.options.overlay.message = message;
                        }
                        if (this.options.actions[i].overlay.buttons) {
                            this.options.overlay.buttons =
                                this.options.actions[i].overlay.buttons;
                        }
                        this.options.overlay_show = !this.options.overlay_show;
                        return;
                    }
                }
            }

            await this._toolClick(a, row)
        },
        async btable_excel(data) {
            console.log(data)
            try {
                const response = await apolloClient.query({
                    query: gql`
                  query setup_report_excel($data: String, $options: String) {
                    setup_report_excel(data: $data, options: $options)
                  }
                `,
                    variables: {
                        data: JSON.stringify(data),
                        options: JSON.stringify({}),
                    },
                });


                let workbook = new ExcelJS.Workbook();
                workbook.model = JSON.parse(response.data.setup_report_excel);
                workbook.created = new Date();
                workbook.modified = new Date();
                let buffer = await workbook.xlsx.writeBuffer();
                fs.saveAs(
                    new Blob([buffer], { type: "application/octet-stream" }),
                    "export" + this.$moment().format("_YYYYMMDDHHMMSS") + ".xlsx"
                );
            } catch (error) {
                console.log(error);
            }
        },
        // TOOLBAR HELPERS
        async toolClick(a) {
            console.log("mixin toolClick: ", a);
            if (this.options) {
                this.options.overlay_show = false;
            }
            if (this.btable_items) {
                for (let k = 0; k < this.btable_items.length; k++) {
                    this.btable_items[k]._showDetails = false;
                }
            }
            switch (a) {
                case "filter":
                    this.showfilter = !this.showfilter
                    break;
                case "discard":
                    this.component = null;
                    this.btable_selected = []
                    if (this.$refs.btable) { this.$refs.btable.clearSelected(); }
                    break;
                case "refresh":
                    this.btable_selected = []
                    if (this.$refs.btable) { this.$refs.btable.clearSelected(); }
                    if (this.currentpage) {
                        this.offset = 0
                        this.currentpage = 1
                    }
                    await this.load();
                    break;
                case "copyit":
                    await this.copyit();
                    break;
                case "deleteit":
                    await this.deleteit();
                    break;
                case "export":
                    let data = await this.load(0, this.export_limit)
                    await this.btable_excel({
                        items: data,
                        fields: this.options.fields,
                    });
                    await this.load()
                    this.btable_busy = false
                    break;

                // case "add":
                // case "import":
                default:
                    let toolactive = this.tools.find((o) => o.action == a);
                    console.log('toolactive', a, toolactive)
                    // CLEAR THE SELECTION IF ADDING!
                    if (a == "add") {
                        this.btable_selected = []
                        if (this.$refs.btable) { this.$refs.btable.clearSelected(); }
                    }
                    if (toolactive) {
                        if (toolactive.component) {
                            if (toolactive.component.name == this.component) {
                                this.component = null;
                                this.cconfig = null;
                            } else {
                                this.component = toolactive.component.name;
                                if (toolactive.component.config) {
                                    this.cconfig = toolactive.component.config;
                                }
                                this.cconfig = { action: a, ...this.config }
                                // if (a=="copy") {
                                //     // this.cconfig =
                                // }
                            }
                        }
                    }
                    break;
            }
            try {
                await this._toolClick(a, this.btable_selected)
            } catch (error) {

            }

        },
        toolDisabled(a) {
            switch (a) {
                case "edit":
                case "copy":
                    return this.btable_selected.length == 1 ? false : true;
                case "deleteall":
                    return this.btable_selected.length > 0 &&
                        this.btable_selected.length == this.btable_items.length
                        ? false
                        : true;
                case "delete":
                case "export":
                    return this.btable_items.length > 0 ? false : true;
            }
            try {
                return this._toolDisabled(a)
            } catch (error) {

            }

        },
        toolLabel(a) {
            switch (a.action) {
                case "filter":
                    return this.showfilter ? 'Filter On' : 'Filter Off'
                default:
                    return a.label
            }
        },
        toolIcon(a) {
            switch (a.action) {
                // case "filter":
                //     return this.showfilter ? a.icon + ' text-danger' : a.icon + ' text-primary'
                default:
                    return a.icon
            }
        },
        toolRemove(a) {
            if (a) {
                let list = a.split(',')
                for (let i = 0; i < list.length; i++) {
                    let idx = this.tools.findIndex((o) => o.action == list[i])
                    if (idx != -1) {
                        this.tools.splice(idx, 1);
                    }
                }
            }
        },
        toolComponents(a) {
            for (let i = 0; i < a.length; i++) {
                let tool = a[i]
                let component = this.tools.find(o => o.action == tool.action).component
                if (component) {
                    for (let prop in tool) {
                        if (tool[prop] != "action") {
                            component[prop] = tool[prop]
                        }
                    }
                }
            }
        },
        // TREESELECT HELPERS
        async treeselect_loadEvent({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                if (searchQuery.length > 3) {
                    let data = [];
                    let variables = {
                        fuzzy: searchQuery,
                    };
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                      query events($fuzzy: String) {
                        events(fuzzy: $fuzzy) {
                         id:eventcode
                         label
                        }
                      }
                    `,
                            variables,
                        });

                        data = response.data.events;
                    } catch (error) {
                        console.log(error);
                    }
                    callback(null, data);
                } else {
                    callback(null, []);
                }
            }
        },
        async treeselect_loadSLACGroup({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                if (searchQuery.length > 2) {

                    let data = [];
                    let variables = {
                        fuzzy: searchQuery
                    };
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                            query setup_clientgroups($fuzzy: String) {
                                setup_clientgroups(fuzzy: $fuzzy) {
                                id: code
                                label
                                }
                            }
                            `,
                            variables,
                        });

                        data = response.data.clients;
                    } catch (error) {
                        console.log(error);
                    }
                    callback(null, data);
                } else {
                    callback(null, []);
                }
            }
        },
        async treeselect_loadSLAC({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                if (searchQuery.length > 2) {

                    let active = this.user.department == 'ACCOUNTS' || this.user.department == 'DEVELOPMENT' ? null : "true"

                    let data = [];
                    let variables = {
                        fuzzy: searchQuery,
                        active
                    };
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                      query clients($fuzzy: String, $active:String) {
                        clients(fuzzy: $fuzzy, active: $active) {
                          id: slac
                          label
                        }
                      }
                    `,
                            variables,
                        });

                        data = response.data.clients;
                    } catch (error) {
                        console.log(error);
                    }
                    callback(null, data);
                } else {
                    callback(null, []);
                }
            }
        },
        async treeselect_loadBLAC({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                if (searchQuery.length > 1) {

                    // let active = "true"
                    // if (this.fuzzyall) { active = null }

                    let active = this.user.department == 'ACCOUNTS' || this.user.department == 'DEVELOPMENT' ? null : "true"

                    let data = [];
                    let variables = {
                        fuzzy: searchQuery,
                        active,
                    };
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                            query suppliers($fuzzy: String, $active:String) {
                                suppliers(fuzzy: $fuzzy, active: $active) {
                                id: blac
                                label
                                }
                            }
                            `,
                            variables,
                        });

                        data = response.data.suppliers;
                    } catch (error) {
                        console.log(error);
                    }
                    callback(null, data);
                } else {
                    callback(null, []);
                }
            }
        },
        async treeselect_loadNLCode({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                if (searchQuery.length > 0) {
                    let data = [];
                    let variables = {
                        fuzzy: searchQuery,
                    };
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                      query nlcodes {
                            nlcodes {
                                id
                                label
                            }
                      }
                    `,
                            variables,
                        });

                        data = response.data.nlcodes;
                    } catch (error) {
                        console.log(error);
                    }
                    callback(null, data);
                } else {
                    callback(null, []);
                }
            }
        },
        async treeselect_loadSuppliertypes({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                if (searchQuery.length > 0) {
                    let data = [];
                    let variables = {
                        fuzzy: searchQuery,
                    };
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                      query suppliertypes($fuzzy: String) {
                        suppliertypes(fuzzy: $fuzzy) {
                         id
                         label
                        }
                      }
                    `,
                            variables,
                        });

                        data = response.data.suppliertypes;
                    } catch (error) {
                        console.log(error);
                    }
                    callback(null, data);
                } else {
                    callback(null, []);
                }
            }
        },
        async treeselect_loadPAYBY({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                if (searchQuery.length > 2) {
                    let data = [];
                    let variables = {
                        fuzzy: searchQuery,
                    };
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                      query bookingformspaytypes($fuzzy: String) {
                        bookingformspaytypes(fuzzy: $fuzzy) {
                          id
                          label
                        }
                      }
                    `,
                            variables,
                        });

                        data = response.data.bookingformspaytypes;
                    } catch (error) {
                        console.log(error);
                    }
                    callback(null, data);
                } else {
                    callback(null, []);
                }
            }
        },
        async treeselect_loadVATRATE({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                if (searchQuery.length > 0) {
                    let data = [];
                    let variables = {
                        fuzzy: searchQuery,
                    };
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                      query setup_vatrates($fuzzy: String) {
                        setup_vatrates(fuzzy: $fuzzy) {
                          id: code
                          label
                        }
                      }
                    `,
                            variables,
                        });

                        data = response.data.setup_vatrates;
                    } catch (error) {
                        console.log(error);
                    }
                    callback(null, data);
                } else {
                    callback(null, []);
                }
            }
        },
        async treeselect_loadSalesgroups({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                if (searchQuery.length > 1) {
                    let data = [];
                    let variables = {
                        fuzzy: searchQuery,
                    };
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                      query salesgroups($fuzzy: String) {
                        salesgroups(fuzzy: $fuzzy) {
                         id
                         label
                        }
                      }
                    `,
                            variables,
                        });

                        data = response.data.salesgroups;
                    } catch (error) {
                        console.log(error);
                    }
                    callback(null, data);
                } else {
                    callback(null, []);
                }
            }
        },
        async treeselect_loadPayments({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                if (searchQuery.length > 2) {
                    let data = [];
                    let variables = {
                        fuzzy: searchQuery,
                        slac: this.ppslac
                    };
                    console.log("variables", variables);
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                      query SLPayments($fuzzy: String, $slac: String) {
                        SLPayments(fuzzy: $fuzzy, slac: $slac) {
                          id: ref
                          label
                        }
                      }
                    `,
                            variables,
                        });

                        data = response.data.SLPayments;
                    } catch (error) {
                        console.log(error);
                    }
                    callback(null, data);
                } else {
                    callback(null, []);
                }
            }
        },

        async treeselect_loadIATA({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                if (searchQuery.length > 2) {
                    let data = [];
                    let variables = {
                        fuzzy: searchQuery,
                    };
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                      query setup_airports($fuzzy: String) {
                        setup_airports(fuzzy: $fuzzy) {
                          id: iata_code
                          label
                        }
                      }
                    `,
                            variables,
                        });

                        data = response.data.setup_airports;
                    } catch (error) {
                        console.log(error);
                    }
                    callback(null, data);
                } else {
                    callback(null, []);
                }
            }
        },

        async treeselect_loadAirport({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                if (searchQuery.length > 2) {
                    let data = [];
                    let variables = {
                        fuzzy: searchQuery,
                    };
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                      query setup_airports($fuzzy: String) {
                        setup_airports(fuzzy: $fuzzy) {
                          id: iata_code
                          label
                        }
                      }
                    `,
                            variables,
                        });

                        data = response.data.setup_airports;
                    } catch (error) {
                        console.log(error);
                    }
                    callback(null, data);
                } else {
                    callback(null, []);
                }
            }
        },

        async treeselect_loadAircraft({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                if (searchQuery.length > 2) {
                    let data = [];
                    let variables = {
                        fuzzy: searchQuery,
                    };
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                      query setup_aircrafts($fuzzy: String) {
                        setup_aircrafts(fuzzy: $fuzzy) {
                            id: iatacode
                            label
                        }
                      }
                    `,
                            variables,
                        });

                        data = response.data.setup_aircrafts;
                    } catch (error) {
                        console.log(error);
                    }
                    callback(null, data);
                } else {
                    callback(null, []);
                }
            }
        },

        async treeselect_loadAirline({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                if (searchQuery.length > 1) {
                    let data = [];
                    let variables = {
                        fuzzy: searchQuery,
                    };
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                      query setup_airlines($fuzzy: String) {
                        setup_airlines(fuzzy: $fuzzy) {
                            id: code
                            label
                        }
                      }
                    `,
                            variables,
                        });

                        data = response.data.setup_airlines;
                    } catch (error) {
                        console.log(error);
                    }
                    callback(null, data);
                } else {
                    callback(null, []);
                }
            }
        },

        async treeselect_loadEMDTypes({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                if (searchQuery.length > 1) {
                    let data = [];
                    let variables = {
                        fuzzy: searchQuery,
                    };
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                            query setup_emdremarks($fuzzy: String) {
                                setup_emdremarks(fuzzy: $fuzzy) {
                                    id: description
                                    label: description
                                }
                            }
                            `,
                            variables,
                        });

                        data = response.data.setup_emdremarks;
                    } catch (error) {
                        console.log(error);
                    }
                    callback(null, data);
                } else {
                    callback(null, []);
                }
            }
        },


        async treeselect_loadTicket({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                if (searchQuery.length > 6) {
                    let data = [];
                    let variables = {
                        fuzzy: searchQuery,
                        mssql: true
                    };
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                      query tickets($mssql: Boolean, $fuzzy: String) {
                        tickets(mssql:$mssql fuzzy: $fuzzy) {
                         id:ticketno       
                         label                  
                        }
                      }
                    `,
                            variables,
                        });

                        data = response.data.tickets;
                    } catch (error) {
                        console.log(error);
                    }
                    callback(null, data);
                } else {
                    callback(null, []);
                }
            }
        },

        async treeselect_loadCar({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                if (searchQuery.length > 2) {
                    let data = [];
                    let variables = {
                        fuzzy: searchQuery,
                    };
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                      query carbookings($fuzzy: String) {
                        carbookings(fuzzy: $fuzzy) {
                         id:confirmationno                         
                        }
                      }
                    `,
                            variables,
                        });

                        data = response.data.carbookings;
                    } catch (error) {
                        console.log(error);
                    }
                    callback(null, data);
                } else {
                    callback(null, []);
                }
            }
        },

        async treeselect_loadSLInvoiceno({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                if (searchQuery.length > 2) {

                    let slac = null
                    if (this.item.slac) { slac = this.item.slac }
                    if (this.item.matches) {
                        if (this.item.matches.length > 0) { slac = this.item.matches[0].who }
                    }

                    let data = [];
                    let variables = {
                        fuzzy: searchQuery,
                        slac
                    };
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                      query SLTransactions($fuzzy: String $slac: String) {
                        SLTransactions(fuzzy: $fuzzy slac:$slac) {
                         id: invoiceno     
                         label                                 
                        }
                      }
                    `,
                            variables,
                        });

                        data = response.data.SLTransactions;
                    } catch (error) {
                        console.log(error);
                    }
                    callback(null, data);
                } else {
                    callback(null, []);
                }
            }
        },
        async treeselect_loadBLInvoiceno({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                if (searchQuery.length > 2) {

                    let blac = null
                    if (this.item.blac) { blac = this.item.blac }
                    if (this.item.matches) {
                        if (this.item.matches.length > 0) { blac = this.item.matches[0].who }
                    }

                    let data = [];
                    let variables = {
                        fuzzy: searchQuery,
                        blac
                    };
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                                query BLTransactions($fuzzy: String $blac: String) {
                                    BLTransactions(fuzzy: $fuzzy blac:$blac) {
                                    id: invoiceno     
                                    label                                 
                                    }
                                }
                                `,
                            variables,
                        });

                        data = response.data.BLTransactions;
                    } catch (error) {
                        console.log(error);
                    }
                    callback(null, data);
                } else {
                    callback(null, []);
                }
            }
        },

        async treeselect_loadUser({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                if (searchQuery.length > 0) {
                    let data = [];
                    let variables = {
                        fuzzy: searchQuery,
                    };
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                      query setup_users($fuzzy: String) {
                        setup_users(fuzzy: $fuzzy) {
                         id:email
                         label                        
                        }
                      }
                    `,
                            variables,
                        });

                        data = response.data.setup_users;
                    } catch (error) {
                        console.log(error);
                    }
                    callback(null, data);
                } else {
                    callback(null, []);
                }
            }
        },

        async treeselect_loadBookingform({ action, searchQuery, callback }) {
            if (action === ASYNC_SEARCH) {
                if (searchQuery.length > 2) {
                    let data = [];
                    let variables = {
                        fuzzy: searchQuery,
                    };
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                      query bookingforms($fuzzy: String) {
                        bookingforms(fuzzy: $fuzzy) {
                         id
                         label                        
                        }
                      }
                    `,
                            variables,
                        });

                        data = response.data.bookingforms;
                    } catch (error) {
                        console.log(error);
                    }
                    callback(null, data);
                } else {
                    callback(null, []);
                }
            }
        },

        async excel_sheet(data, title) {
            console.log(title)
            try {
                const response = await apolloClient.query({
                    query: gql`
                  query setup_report_excel($data: String, $title:String, $options: String) {
                    setup_report_excel(data: $data, title: $title, options: $options)
                  }
                `,
                    variables: {
                        data: JSON.stringify(data),
                        title: title,
                        options: JSON.stringify({}),
                    },
                });


                let workbook = new ExcelJS.Workbook();
                workbook.model = JSON.parse(response.data.setup_report_excel);
                workbook.created = new Date();
                workbook.modified = new Date();
                let buffer = await workbook.xlsx.writeBuffer();
                fs.saveAs(
                    new Blob([buffer], { type: "application/octet-stream" }),
                    "export" + this.$moment().format("_YYYYMMDDHHMMSS") + ".xlsx"
                );
            } catch (error) {
                console.log(error);
            }
        },

        // COMPONENT HELPERS
        async outside(e) {
            if (this.options) {
                this.options.overlay_show = false;
            }
        },
        async saveit() {
            console.log("mixin saveit()")
        },
        async fileit() {
            console.log("mixin fileit()")
        },
        async fileUpload_selected(e) {
            if (e.target.files.length > 0) {
                try {
                    this.fileUpload = {
                        name: e.target.files[0].name,
                        size: e.target.files[0].size,
                        type: e.target.files[0].type,
                        date: e.target.files[0].lastModified,
                        data: await this.$helpers.getBase64(e.target.files[0]),
                    };
                } catch (error) {
                    console.log(error);
                }
            }
        },
        async fileUpload_view() {
            if (this.fileUpload) {
                console.log(this.fileUpload)
                if (this.fileUpload.data) {
                    let byteCharacters = atob(this.fileUpload.data);
                    let byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    let byteArray = new Uint8Array(byteNumbers);
                    let blob = new Blob([byteArray], { type: this.fileUpload.type });
                    fs.saveAs(blob, this.fileUpload.name);
                }
            }
        },
        fileUpload_clear() {
            this.$refs['file-input'].reset()
            this.fileUpload = null
        },
        cleanit(e) {
            let r = e
            if (Array.isArray(e)) {
                let a = []
                for (let i = 0; i < e.length; i++) {
                    r = { ...e[i] }
                    for (let prop in r) {
                        switch (prop) {
                            case "__typename":
                            case "_showDetails":
                            case "created_by":
                            case "created_at":
                            case "updated_by":
                            case "updated_at":
                            case "rows":
                                delete r[prop]
                                break;
                        }
                    }
                    a.push(r)
                }
                r = a
            } else {
                r = { ...e }
                for (let prop in r) {
                    switch (prop) {
                        case "__typename":
                        case "_showDetails":
                        case "created_by":
                        case "created_at":
                        case "updated_by":
                        case "updated_at":
                        case "rows":
                            delete r[prop]
                            break;
                    }
                }
            }
            return r
        },
        async getsystemsetting(name) {
            const response = await apolloClient.query({
                query: gql`
                      query setup_systemsettings($name: String) {
                        setup_systemsettings(name: $name) {
                          data
                        }
                      }
                    `,
                variables: { name }
            });
            let result = response.data.setup_systemsettings[0].data;
            return result;
        },
        async setsystemsetting(name, data) {
            const response = await apolloClient.mutate({
                mutation: gql`
                      mutation setup_systemsettings_save($rows: [setup_systemsettings_input]) {
                        setup_systemsettings_save(rows: $rows) {
                            id
                            data
                        }
                      }
                    `,
                variables: { rows: [{ name, data }] }
            });
            let result = response.data.setup_systemsettings_save
            return result;
        },
        async toggle_invoicingstate() {
            let state = await this.getsystemsetting("invoicing_enabled")
            if (state == 'yes') {
                await this.setsystemsetting("invoicing_enabled", "no")
            } else {
                await this.setsystemsetting("invoicing_enabled", "yes")
            }
        },
        changeTextsize() {
            if (this.textsize == "") {
                this.textsize = "bigger";
            } else if (this.textsize == "bigger") {
                this.textsize = "biggest";
            } else if (this.textsize == "biggest") {
                this.textsize = "biggest2";
            }
            else if (this.textsize == "biggest2") {
                this.textsize = "";
            }
        },
        treeselect(n) {
            console.log('treeselect', n.label)
            this.eventtitle = n.label;
        },
        tree_clientlabel(n) {
            this.clienttitle = n.label;
        },
        discard() {
            this.$emit("refresh");
            this.$emit("discard");
        },
        permissionvalid(permission) {
            if (this.user) {
                if (this.user.permissions) {
                    if (this.user.permissions.includes(permission)) {
                        return true
                    } else {
                        return false
                    }
                }
            }
        },
        // Mirrors tp_server resolvers/ledgerloader.js requireexplicitaccess: explicit grant only,
        // no admin shortcut; the api string must be present in Setup_Users.permissions.
        // permissionvalid() is an includes() check, which works whether permissions is a
        // JSON array or a string, exactly like the server's indexOf().
        ledgerloaderallowed(api) {
            if (!this.user) return false
            return !!this.permissionvalid(api || '/api/mutation/ledgerloader_preview')
        },
        nocomma(value) {
            return value.split(",").join("");
        },
        onlynumbers(value) {
            return value.replace(/[^0-9.-]/g, '')
        },
        async timestamp(column) {
            if (typeof column === "object") { column = "notes" }
            console.log(column)
            let result = ""
            if (this.item[column]) {
                result += this.item[column] + "\n"
            }
            result += this.$moment().format("DD/MM/YY HH:mm") +
                " " +
                this.user.initials +
                "\n";
            this.item[column] = result
        },
        async load_mifields(keeprequirement) {

            this.mifields = [];

            let mifields_enabled = await this.getsystemsetting('mifields_enabled')
            if (mifields_enabled == 'no') { return }

            if (!this.item.slac) { return }

            if (mifields_enabled == 'yes' || mifields_enabled.split(",").includes(this.item.slac)) {

                if (typeof this.item.tags === 'object' && this.item.tags !== null) {
                    this.item.tags = JSON.stringify(this.item.tags)
                }
                let tags = this.item.tags == null ? {} : JSON.parse(this.item.tags)

                if (!keeprequirement) {
                    this.requirement = {}
                }

                let variables = {
                    slac: this.item.slac,
                    stype: this.item.stype ? this.item.stype : null,
                    active: "1",
                };
                const response = await this.$apollo.query({
                    query: gql`
                    query setup_mifields($slac: String, $stype: String, $active: String) {
                        setup_mifields(slac: $slac, stype:$stype, active: $active) {
                                key
                                type
                                stype
                                label
                                options
                                required
                                value
                                active
                            }
                        }
                    `,
                    variables,
                    fetchPolicy: "no-cache",
                });
                this.mifields = JSON.parse(JSON.stringify(response.data.setup_mifields))
                if (this.mifields) {
                    for (var i = 0; i < this.mifields.length; i++) {
                        if (this.mifields[i].options) {
                            this.mifields[i].options = JSON.parse(this.mifields[i].options)
                        }
                        // SET REQUIREMENTS OBJECT
                        if (this.mifields[i].required == "1" || this.mifields[i].stype) {
                            if (this.mifields[i].stype) {
                                if (this.item.stype) {
                                    if (this.mifields[i].stype.includes(this.item.stype)) {
                                        this.requirement[this.mifields[i].key] = this.mifields[i].label;
                                    }
                                }
                            } else {
                                this.requirement[this.mifields[i].key] = this.mifields[i].label;
                            }
                        } else {
                            this.mifields[i].value = null
                        }

                        // if (this.mifields[i].required == "1") {
                        //     if (this.item.issued_at) {
                        //         if (this.$moment(this.item.issued_at).utc(false).isBefore('2025-10-01')) {
                        //             this.mifields[i].required = "0"
                        //             this.requirement = ""
                        //         }
                        //     }
                        // }
                    }
                }
                // if (tags) {
                for (var prop in tags) {
                    let found = this.mifields.find(o => o.key == prop);
                    if (prop == "mi_P") {
                        if (this.item.yourref) {
                            tags[prop] = this.item.yourref
                        }
                    }
                    if (found) {
                        if (tags[prop]) {
                            if (found.options) {
                                let ddvalue = found.options.find(o => o.id.toLowerCase() == tags[prop].toLowerCase());
                                if (ddvalue) {
                                    found.value = ddvalue.id
                                } else {
                                    found.value = null //tags[prop];
                                }
                            } else {
                                found.value = tags[prop];
                            }
                        }
                    }
                }
                this.item.tags = JSON.stringify(tags)
            }
        },
        async mifields_requirement() {
            let requirements = "";
            for (var prop in this.requirement) {
                if (prop.slice(0, 3) == 'mi_') {
                    let found = this.mifields.find(o => o.key == prop);
                    if (found) {
                        console.log('found.value', found.value)
                        if (found.value == null || found.value == '') {
                            requirements += this.requirement[prop] + ",";
                            // break;
                        }
                    }
                }
            }
            return requirements
        }
    },

}
